import { Component, Input } from '@angular/core';
import { TourItem } from '../../model/tour/tour-item';

@Component({
  selector: 'tour-item-registered',
  templateUrl: './tour-item-registered.component.html',
})
export class TourItemRegisteredComponent {
  @Input()
  tourItem?: TourItem;
}
